import { render } from "./Tablet.vue?vue&type=template&id=cccd8c3c"
import script from "./Tablet.vue?vue&type=script&lang=js"
export * from "./Tablet.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Tablet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cccd8c3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cccd8c3c', __exports__)) {
    api.reload('cccd8c3c', __exports__)
  }
  
  module.hot.accept("./Tablet.vue?vue&type=template&id=cccd8c3c", () => {
    api.rerender('cccd8c3c', render)
  })

}


export default __exports__